import type { PaymentMethodToken } from "./generated/graphql";

import type {
  HighnoteEnvironment,
  SecureInputsTokenizationError,
  cardBrands,
} from ".";

export type CheckoutCardBrand = (typeof cardBrands)[number];

export enum CheckoutPostMessageKind {
  TOKENIZE_SUCCCESS = "TOKENIZE_SUCCCESS",
  TOKENIZE_ERROR = "TOKENIZE_ERROR",
  CHECKOUT_READY = "CHECKOUT_READY",
}

export class CheckoutConfigInputError extends Error {
  public name = "CheckoutConfigInputError";

  public errors: { message: string; field: string }[];

  public constructor(
    message: string,
    errors: { message: string; field: string }[]
  ) {
    super(message);

    this.errors = errors;
  }
}

export interface CheckoutReady {
  kind: CheckoutPostMessageKind.CHECKOUT_READY;
}

export interface TokenizeError {
  kind: CheckoutPostMessageKind.TOKENIZE_ERROR;
  error: SecureInputsTokenizationError;
}

export type CheckoutPostMessageEvent =
  | CheckoutReady
  | TokenizeError
  | {
      kind: CheckoutPostMessageKind.TOKENIZE_SUCCCESS;
      token: PaymentMethodToken;
    };

export type OnTokenizeError = SecureInputsTokenizationError;

export interface OnTokenizeSuccessPayload {
  token: PaymentMethodToken;
}

export interface AdditionalFormSections {
  cardHolderName?: boolean;

  billingAddress?: boolean;
}

export const allowedCheckoutConfigSubmitButtonText = ["Pay", "Submit"] as const;
export type CheckoutConfigSubmitButtonText =
  (typeof allowedCheckoutConfigSubmitButtonText)[number];

export interface CheckoutConfigSubmitButton {
  /**
   * The text to display on the submit button
   */
  text?: CheckoutConfigSubmitButtonText;
}

export interface CheckoutConfig {
  additionalFormSections?: AdditionalFormSections;

  clientToken: string;

  selector: string;

  environment?: HighnoteEnvironment;

  onTokenizeError: (error: OnTokenizeError) => void;

  onTokenizeSuccess: (payload: OnTokenizeSuccessPayload) => void;

  /**
   * Specifies a list of card brands to be excluded from the checkout form,
   * preventing the card brands from being processed.
   */
  excludedCardBrands?: CheckoutCardBrand[];

  /**
   * Configuration for the submit button.
   */
  submitButton?: CheckoutConfigSubmitButton;
}

export interface CheckoutReturn {
  unmount: () => void;
}
